import * as ActionTypes from '../constants/ActionTypes'

// **************************************************************************************************************
export const clientDataStepReducer = (state = {existingCustomerSelected: false, newCustomerSelected: true, existingUserAuthenticated: false, isFetchingClientData: false, clientData: false, customerNumber: false}, action) => {

    switch (action.type) {

        case ActionTypes.CLIENTDATA_SELECT_NEW:

            return Object.assign({}, state, {existingCustomerSelected: false, newCustomerSelected: true, existingUserAuthenticated: false, clientData: false})

        case ActionTypes.CLIENTDATA_SELECT_EXISTING:

            return Object.assign({}, state, {existingCustomerSelected: true, newCustomerSelected: false})

        case ActionTypes.AUTHENTICATION_CACHED:
        case ActionTypes.AUTHENTICATION_SUCCESS:

            return Object.assign({}, state, {existingCustomerSelected: true, newCustomerSelected: false, existingUserAuthenticated: true})

        case ActionTypes.CLIENTNUMBER_REQUEST:
        case ActionTypes.CLIENTDATA_REQUEST:

            return Object.assign({}, state, {isFetchingClientData: true})

        case ActionTypes.CLIENTDATA_FAILURE:
            return Object.assign({}, state, {isFetchingClientData: false})

        case ActionTypes.CLIENTDATA_SUCCESS:

            return Object.assign({}, state, {existingUserAuthenticated: true, isFetchingClientData: false, clientData: action.response.result, customerNumber: action.payload.customerNumber})

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/ClientData.js
 **/